<template>
  <a-modal
    v-model="showModal"
    :centered="true"
    height="100%"
    class="mobile-modal-fullscreen"
    :footer="null"
    :closable="false"
    :bodyStyle="{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '24px',
      gap: '24px',
      position: 'relative',
    }"
    width="587px"
  >
    <div class="header">
      <span :style="{ marginRight: '24px' }" @click="handleback"><font-awesome-icon size="lg" class="xmark" :icon="['far', 'arrow-left']"/></span>
      <span class="title">Create Press Release</span>
      <div @click="handleCancel()" class="close-mob">
        <font-awesome-icon size="1x" class="xmark" :icon="['far', 'times']" />
      </div>
      <button
        @click="handleApply"
        class="apply-filter-btn-mob"
        :style="{ background: getPrimaryColor(), opacity: !subject ? 0.5 : 1, cursor: !subject ? 'auto !important' : 'pointer' }"
        :disabled="!subject"
      >
        Done
      </button>
    </div>
    <div class="cont">
      <template v-if="addingImages">
        <div v-if="isImageUploading" class="d-flex justify-content-center mt-2 w-100">
          <div>
            <div class="spinner-border position-absolute spinner-class"></div>
          </div>
          <div :style="{ 'margin-left': '-33px', 'margin-top': '40px' }">Loading image...</div>
        </div>
        <div class="w-100" v-else-if="!fileList.length && !isImageUploading">
          <!-- @click="handleImageUpload" -->
          <div class="add-symptoms">
            <div class="add-img-cont">
              <input
                class="camera-icon-inp position-absolute"
                type="file"
                accept="image/png, image/jpeg, image/gif, image/svg+xml"
                ref="fileInput"
                @change="handleImageUpload"
                :style="{ right: 0, cursor: 'pointer', width: '100%', height: '100%', opacity: '0' }"
              />
              <div class="plus-icon">
                <font-awesome-icon size="1x" class="mr-2" :style="{ color: getPrimaryColor() }" :icon="['fas', 'plus']" />
              </div>
              <span class="add-img-text" :style="{ color: getPrimaryColor() }"> Add Image </span>
              <span class="add-img-subtext hide-in-mobile">or drag and drop</span>
            </div>
          </div>
        </div>
        <div class="position-relative image-cont" v-else>
          <font-awesome-icon
            :icon="['far', 'times']"
            class="gray500 position-absolute bg-gray100 p-1 ar1 font20 rounded-circle cp"
            :style="{ top: '10px', right: '10px', 'z-index': 10, height: '24px', width: '24px' }"
            @click="handleCancelImage"
          />
          <img class="img" v-if="fileList.length" :src="fileList[0].url" />
        </div>
      </template>
      <div class="sub-cont">
        <span class="head">Subject <span class="red300">*</span></span>
        <a-input class="input" placeholder="Subject" v-model="subject" />
      </div>
      <div class="sub-cont">
        <span class="head">Description</span>
        <a-textarea :resize="none" class="text-area" placeholder="Description" v-model="texts" :maxlength="2500" />
        <span class="count-text">{{ texts.length }}/2500</span>
      </div>
      <div class="sub-cont">
        <span class="head">Link</span>
        <a-input class="input" placeholder="Enter a valid url" v-model="link" />
      </div>
    </div>
    <div class="footer">
      <button
        @click="handleApply"
        class="apply-filter-btn"
        :style="{ background: getPrimaryColor(), opacity: !subject ? 0.5 : 1, cursor: !subject ? 'auto !important' : 'pointer' }"
        :disabled="!subject"
      >
        Done
      </button>
    </div>
  </a-modal>
</template>

<script>
import { faArrowLeft, faTimes } from "@fortawesome/pro-regular-svg-icons"
import { faCheck } from "@fortawesome/pro-solid-svg-icons"
import { library } from "@fortawesome/fontawesome-svg-core"
import s3Upload from "../../utilities/imageUploader"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"

const AppRepository = RepositoryFactory.get("app")
const UserRepository = RepositoryFactory.get("user")
library.add(faArrowLeft, faTimes, faCheck)

export default {
  name: "createPressRelease",
  props: {
    handleOtherModals: Function,
  },
  data() {
    return {
      isImageUploading: false,
      addingImages: true,
      fileList: [],
      texts: "",
      link: "",
      subject: "",
      showModal: false,
      data: {},
      editing: false,
      editingTags: [],
      editingId: 0,
    }
  },
  methods: {
    handleCancelImage() {
      this.fileList = []
    },

    handleApply() {
      // console.log(this.texts, this.link, this.subject)
      if (!this.subject) {
        this.$notification.error({
          message: "Error",
          description: "You need to fill all the necessary fields correctly to create Press.",
        })
      } else {
        this.handleOtherModals(
          "add",
          {
            subject: this.subject,
            link: this.link,
            des: this.texts,
            img: this.fileList,
          },
          "press",
          this.editing,
          this.editingTags,
          this.editingId
        )
        this.handleCancel()
      }
    },

    async handleImageUpload() {
      if (this.fileList.length) {
        this.$notification.error({
          message: "Error",
          description: "Cannot add more than one image",
        })
      } else {
        const file = this.$refs.fileInput.files[0]
        this.isImageUploading = true
        try {
          if (file.size / (1024 * 1024) > 5) {
            this.$notification.error({
              message: "Error",
              description: "File size exceeds 5MB limit",
            })
            const input = this.$refs.file
            input.type = "text"
            input.type = "file"
          } else if (!file.type.includes("image")) {
            this.$notification.error({
              message: "Error",
              description: "Please select only image",
            })
          } else {
            const urlPayload = { file_name: [file.name] }
            const urlData = await UserRepository.getPresignedUrl(urlPayload)
            const fileName = urlData.data.data.filename[0]
            await s3Upload(urlData.data.data.url[0], file)
            // this.post_attach.push(fileName)
            const fileListData = {
              name: fileName,
              status: "done",
              url: urlData.data.data.preview_url,
            }
            this.fileList.push(fileListData)
          }
        } catch (err) {
          console.log(err)
        }
        this.isImageUploading = false
      }
    },

    handleback() {
      this.handleCancel()
      this.handleOtherModals("back")
    },

    show(data, edit = false, tags = [], id = 0) {
      this.editing = edit
      this.editingTags = tags
      this.editingId = id
      // console.log('Press editing ->',this.editing);
      this.showModal = true
      if (data) {
        this.link = data.link ? data.link : ""
        this.fileList = data.img ? data.img : []
        this.texts = data.des ? data.des : ""
        this.subject = data.subject ? data.subject : ""
      } else {
        this.link = ""
        this.fileList = []
        this.texts = ""
        this.subject = ""
      }
    },

    handleCancel() {
      this.showModal = false
    },
  },
}
</script>

<style lang="scss" scoped>
.apply-filter-btn-mob {
  display: none;
  @media screen and (max-width: 700px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    width: 82px;
    height: 48px;
    border-radius: 6px;
    text-transform: capitalize;
    color: #ffffff;
    border: none;
    cursor: pointer;
  }
}

.close-mob {
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.img {
  width: 100%;
}
.image-cont {
  width: 100%;
  //   width: 539px;
  // height: 278px;
}
.count-text {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  text-transform: capitalize;
  color: #94a3b8;
  width: 100%;
  justify-content: flex-end;
  margin-top: 4px;
}

.text-area {
  min-height: 151px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #0f1734;
  resize: none;
}

.input {
  // width: 539px;
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #0f1734;
}

textarea::placeholder {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94a3b8;
}
.input::placeholder {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94a3b8;
}
.sub-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  // min-width: 539px;
  width: 100%;
  min-height: 92px;
}
.head {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 32px;
  color: #647490;
}

.add-symptoms {
  width: 100%;
  // min-width: 539px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
  min-height: 94px;
  background: rgba(37, 103, 237, 0.05);
  border: 1px dashed #94a3b8;
  // background-image: linear-gradient(#94a3b8 33%, rgba(255, 255, 255, 0) 0%);
  // background-position: right;
  background-size: 1px 16px;
  background-repeat: repeat-y;
  position: relative;
  cursor: pointer;
  @media screen and (max-width: 700px) {
    min-height: 171px;
    border: 1.5px dashed #94a3b8;
  }
  .border-top,
  .border-bottom {
    position: absolute;
    border: none;
    left: 7px;
    margin: 0;
  }
  .border-top {
    top: -25px;
    &::after {
      content: "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
      letter-spacing: 4px;
      height: 0;
      overflow: hidden;
      color: #94a3b8;
    }
  }
  .border-left {
    position: absolute;
    background-image: linear-gradient(#94a3b8 33%, rgba(255, 255, 255, 0) 0%);
    /* background-position: left; */
    background-size: 1px 17px;
    background-repeat: repeat-y;
    height: 55px;
    width: 10px;
    left: 0;
  }
  .border-bottom {
    bottom: -30px;
    &::after {
      content: "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
      letter-spacing: 4px;
      height: 0;
      overflow: hidden;
      color: #94a3b8;
    }
  }
  .addsymtoms-text {
    font-family: "Lato";
    font-weight: 700;
    color: #2a71d4;
  }
  // .plus-icon{
  //   // font-size: 30px;
  // }
  .addsymtoms-text {
    font-size: 14px;
    margin: 0 8px;
  }

  @media screen and (max-width: 900px) {
    height: 56px;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.add-img-subtext {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #647490;
}
.add-img-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}
.add-img-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 4px;
}
.cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 24px;
  gap: 24px;
  width: 100%;
}
.image-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 24px;
}

.image {
  width: 539px;
  height: 132px;
  border-radius: 8px;
  background-color: violet;
  background-blend-mode: screen multiply;
}

.image:hover {
  background: #2a71d4;
  opacity: 0.5;
}

.avatar:hover {
  background: #2a71d4;
  opacity: 0.5;
}

.apply-filter-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 82px;
  height: 48px;
  background: #2a71d4;
  border-radius: 6px;
  text-transform: capitalize;
  color: #ffffff;
  border: none;
  cursor: pointer;
}

.cancel-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 91px;
  height: 48px;
  background: #e2e8f0;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #47556e;
  border: none;
  cursor: pointer;
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 10px;
  width: 100%;
  // width: 539px;
  height: 48px;
  // margin-top: 104px;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.category-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  color: #33415f;
}

.grid-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 20px;
}
.condition-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  height: 727px;
  overflow-y: scroll;
}

.condition-container::-webkit-scrollbar {
  width: 0 !important;
}
// .close{
// display: flex;
// flex-direction: column;
// justify-content: center;
// align-items: flex-end;
// padding: 0px;
// width: 480px;
// height: 24px;
// }

.xmark {
  // width:12.5px;
  height: 20px;
  cursor: pointer;
  color: #94a3b8;
}
.title {
  width: 100%;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #33415f;
  @media screen and (max-width: 700px) {
    font-size: 20px !important;
  }
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 100%;
  // width: 539px;
  height: 29px;
}

.modalContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 24px;
  position: relative;
  width: 587px;
  height: 529px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.ant-modal-content {
  border-radius: 8px;
}

.fw700 {
  font-weight: 700;
}

.mainHeading {
  font-size: 24px;
  line-height: 32px;
  color: #33415f !important;
}

.subHeading {
  font-size: 16px;
  line-height: 32px;
  color: #647490 !important;
  margin-top: 45px;
}

.checkbox,
.checkboxMain {
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-weight: 400;
  font-size: 34px;
  line-height: 21px;
  color: #0f1734 !important;
}

.btn {
  border-radius: 6px;
  font-size: 14px;
  line-height: 24px;
}

.cancel {
  background: #e2e8f0;
  width: 91px;
  height: 48px;

  .cancelColor {
    color: #47556e !important;
  }
}

.apply {
  background: #2a71d4;
  width: 128px;
  height: 48px;

  .applyColor {
    color: #ffffff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/createPressRelease.vue